<form>
   <div class="sam-form-row">
      <label>{{ 'brick.brick_definitions.dynamic-actions-brick.settings.json-configuration.label' | translate }}</label>
      <div class="k-form-field k-form-field-with-icon sam-form-control sam-form-control-full-width">
         <textarea
            kendoTextArea
            fxFlex="1 1 *"
            placeholder="{{
               'brick.brick_definitions.dynamic-actions-brick.settings.json-configuration.placeholder' | translate
            }}"
            [value]="jsonConfiguration$ | async"
            (debouncedInput)="jsonConfigurationChanged($event.target.value)"
            debouncedInputDelay="750"
            rows="14"
         ></textarea>
      </div>
   </div>
</form>
